import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import * as styles from './OnBoardingDelete.css';
import { Button, Header2, Paragraph2 } from '@cian/ui-kit';
import { OnBoarding } from '../OnBoarding';
import { AnimationFade } from '../AnimationFade';
import { getOnBoardingDeleteVisible, hideOnBoardingDeleteVisible } from '../../utils/localStorage';
export function OnBoardingDelete(_ref) {
  var visible = _ref.visible;
  var _React$useState = React.useState(getOnBoardingDeleteVisible()),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    show = _React$useState2[0],
    setShow = _React$useState2[1];
  var handleClose = function handleClose() {
    hideOnBoardingDeleteVisible();
    setShow(false);
  };
  return /*#__PURE__*/React.createElement(AnimationFade, {
    show: visible && show
  }, /*#__PURE__*/React.createElement(OnBoarding, {
    onClose: handleClose
  }, /*#__PURE__*/React.createElement("header", {
    className: styles['header']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['heart']
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['body']
  }, /*#__PURE__*/React.createElement(Header2, null, "\u0423\u0434\u0430\u043B\u0435\u043D\u043E \u0438\u0437 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E"), /*#__PURE__*/React.createElement(Paragraph2, null, "\u041E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u043E \u0438\u0437 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0438 \u0432\u0441\u0435\u0445 \u043F\u043E\u0434\u0431\u043E\u0440\u043E\u043A"), /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    size: "XS",
    onClick: handleClose
  }, "\u041F\u043E\u043D\u044F\u0442\u043D\u043E"))));
}